module.exports = __webpack_public_path__ + "static/media/heart.76a26b90.svg";